import { render } from "./modal_test.vue?vue&type=template&id=2bd258cf"
import script from "./modal_test.vue?vue&type=script&lang=js"
export * from "./modal_test.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__